// Stores (and their city / area) as values of the Location Label Set keys
// (site, city, area) with display names; a store's value carries
// {account_id, city, area, address} in its data, so it exists - and shows in
// the location tree - before any sensor is installed there.
// Note: label values have no owner account in the platform yet, so the API
// shows every store name to every account; the app filters by account.
import { tenantApi } from "../lib/account";

export interface Store { value: string; name: string; city: string; area: string; account_id: string; address: string }

export const slug = (x: string) => x.toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

export async function loadStores(lang: string): Promise<Store[]> {
  const r = await tenantApi<{ items: { value: string; display_name: string | null; data?: Record<string, unknown> }[] }>("GET", `/labels/site/values?lang=${lang}`);
  return r.items.filter((x) => x.data && x.data.city).map((x) => ({
    value: x.value, name: x.display_name || x.value, city: String(x.data!.city || ""), area: String(x.data!.area || ""),
    account_id: String(x.data!.account_id || ""), address: String(x.data!.address || ""),
  }));
}

/** add a store: its city and area values (display names) if new, then the store with its data */
export async function addStore(s: { account_id: string; city: string; area: string; name: string; address: string }) {
  const c = slug(s.city), a = slug(s.area), v = slug(s.name);
  await tenantApi("PUT", `/labels/city/values/${c}`, { display_name: s.city.trim() });
  await tenantApi("PUT", `/labels/area/values/${a}`, { display_name: s.area.trim(), data: { city: c } });
  await tenantApi("PUT", `/labels/site/values/${v}`, { display_name: s.name.trim(), data: { city: c, area: a, account_id: s.account_id, address: s.address.trim() } });
  return v;
}
